window._ = require('lodash');


//window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');


// require('owl.carousel');
// window.Cropper = require('cropperjs');
//


require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-responsive');
window.feather = require('feather-icons');
window.Switchery = require('mohithg-switchery');

window.Swal = require('sweetalert2');

require('jquery-toast-plugin');
require('./../plugins/waypoints/lib/jquery.waypoints.min');
require('jquery.counterup');
require('jquery-knob');
require('./custom');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
